module.exports = {
  tw: require('./tw.js'),
  en: require('./en.js'),
  ja: require('./ja.js'),
  th: require('./th.js'),
};
